import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import FunnelQ4 from '../components/funnel-q4'
import { isLanguageAvailable } from '../constants/languages'
import { useFlagsReady } from '../features/experiments'

export default function Funnel() {
  const { i18n } = useTranslation()
  const [searchParams] = useSearchParams()
  const languageParam = searchParams.get('language')

  useEffect(() => {
    if (!languageParam) return
    const lang = languageParam.toLowerCase()
    if (!isLanguageAvailable(lang)) return
    if (i18n.language !== lang) i18n.changeLanguage(lang)
  }, [languageParam, i18n])

  // Detect embed context (iframe). When embedded, the funnel stage + its
  // backdrop become transparent so the host page's blurry overlay shines
  // through — only the modal card stays visible. Standalone /funnel keeps
  // its own grey backdrop.
  const [embedded, setEmbedded] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') return
    const isEmbedded = window.self !== window.top
    setEmbedded(isEmbedded)
    if (isEmbedded) {
      // Let the host page's blurry backdrop show through — clear html/body bg.
      const prevHtml = document.documentElement.style.background
      const prevBody = document.body.style.background
      document.documentElement.style.background = 'transparent'
      document.body.style.background = 'transparent'
      return () => {
        document.documentElement.style.background = prevHtml
        document.body.style.background = prevBody
      }
    }
  }, [])

  // Modal is always open on /funnel. Closing or finishing resets the flow by
  // remounting the component (key bump). When embedded, also tell the host
  // page to close its modal — the iframe's X-button and backdrop both route
  // here via onClose.
  const [resetKey, setResetKey] = useState(0)

  // Der Funnel friert seine Experiment-Zuteilung beim Mount ein (createForm
  // traegt sie). Deshalb erst mounten, wenn die Flags da sind, hoechstens
  // 1,5 s warten. Danach rendert er im Status quo und zaehlt nicht mit.
  const flagsReady = useFlagsReady()

  const restart = () => {
    // Standalone-Direktlink (z. B. aivy.app verlinkt direkt auf /funnel): hier
    // gibt es keine Host-Seite, das Modal käme beim Schließen nur wieder. Wenn
    // wir per Klick von einer aivy.app-Seite kamen, leiten wir dorthin zurück.
    if (!embedded && typeof window !== 'undefined' && document.referrer) {
      try {
        const ref = new URL(document.referrer)
        const fromAivy = /(^|\.)aivy\.app$/.test(ref.hostname)
        const external = ref.origin !== window.location.origin
        if (fromAivy && external) {
          // history.back() bleibt im bfcache (kein Reload); bei target=_blank
          // gibt es keine History → direkt auf den Referrer navigieren.
          if (window.history.length > 1) window.history.back()
          else window.location.href = document.referrer
          return
        }
      } catch (_) {
        /* kaputter Referrer → normaler Reset unten */
      }
    }
    setResetKey((k) => k + 1)
    if (embedded && typeof window !== 'undefined' && window.parent !== window) {
      window.parent.postMessage({ type: 'AIVY_FUNNEL_CLOSE_REQUESTED' }, '*')
    }
  }

  return (
    <div
      className={`lm-funnel-stage ${embedded ? 'lm-funnel-stage--embedded' : ''}`}
    >
      {flagsReady && <FunnelQ4 key={resetKey} onClose={restart} />}
    </div>
  )
}
